import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import {
  FlatSelect,
  getFlatSelectFormikFieldControlDisabledProps,
} from '../../../../Flat'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  CONTRACT_FORM_FIELD_NAME_BUILDING,
  CONTRACT_FORM_FIELD_NAME_FLAT,
} from '../../../Contract.constants'

import { getContractFlatApiParams } from './FlatField.utils'

function FlatField({ disabled, ...props }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Select={FlatSelect}
      apiParams={getContractFlatApiParams(values)}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Contract.FlatPlaceholderKey'),
          },
        },
      }}
      disabled={disabled || !values[CONTRACT_FORM_FIELD_NAME_BUILDING]}
      emptyValue={null}
      fieldComponentProps={{
        info: values[CONTRACT_FORM_FIELD_NAME_BUILDING]
          ? null
          : t('Contract.FlatSelectBuildingHintKey'),
        label: `${t('Contract.FlatLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getFieldDisabledProps={getFlatSelectFormikFieldControlDisabledProps}
      name={CONTRACT_FORM_FIELD_NAME_FLAT}
    />
  )
}

export default FlatField
